<template>
  <el-dialog
    :visible="visible"
    :title="$t('CargoMsg.Cargo_ElementSettings')"
    width="600px"
    :close-on-click-modal="false"
    class="element-config-dialog"
    @close="handleCancel"
  >
    <!-- 标签页容器 -->
    <el-tabs v-model="activeTab">
      <!-- 元素规则标签页 -->
      <el-tab-pane :label="$t('CargoMsg.Cargo_ElementRules')" name="rules">
        <div class="element-rules">
          <div class="rule-options">
            <el-checkbox
              v-model="form.isReadonly"
              :checked="isReadOnlyElement(element)"
              :disabled="isDefaultReadOnlyElement(element)"
            >
              {{ $t('CargoMsg.Cargo_IsReadOnly') }}
            </el-checkbox>
            <el-checkbox
              v-model="form.isRequire"
              :disabled="element.isDefaultRequire"
            >
              {{ $t('CargoMsg.Cargo_IsRequired') }}
            </el-checkbox>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer">
      <el-button type="primary" @click="handleConfirm">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="handleCancel">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { isReadOnlyElement, isDefaultReadOnlyElement } from '@/class/cargo/model/utils/AiCustomPageUtil'

export default {
  name: 'AiCustomPageElementConfig',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    element: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // 当前激活的标签页
      activeTab: 'rules',
      form: {
        isReadonly: false,
        isRequire: false
      }
    }
  },
  created() {
    if (this.visible && this.element) {
      console.log('[调试] 初始化元素配置:', this.element)
      // 初始化元素配置数据
      this.form = {
        isReadonly: this.element.isReadonly || false,
        isRequire: this.element.isRequire || this.element.isDefaultRequire || false
      }
    }
  },
  methods: {
    handleConfirm() {
      // 如果元素是默认必填，则强制设置isRequire为true
      const updatedElement = {
        ...this.element,
        isReadonly: this.form.isReadonly,
        isRequire: this.element.isDefaultRequire ? true : this.form.isRequire
      }
      console.log('[调试] 元素配置确认:', {
        原元素: this.element,
        表单值: this.form,
        更新后元素: updatedElement
      })
      this.$emit('confirm', updatedElement)
      this.$emit('update:visible', false)
    },
    handleCancel() {
      this.$emit('update:visible', false)
    },
    isDefaultReadOnlyElement(element) {
      return isDefaultReadOnlyElement(element)
    },
    isReadOnlyElement(element) {
      return isReadOnlyElement(element)
    }
  }
}
</script>

<style lang="scss" scoped>
.element-config-dialog {
  .element-rules {
    padding: 16px;

    .rule-title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 16px;
    }

    .rule-options {
      display: flex;
      gap: 24px;
    }
  }
}
</style>
